import React, {Component} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {connect} from 'react-redux'
import { Card} from 'antd'
import { TableComp } from 'sz-react-utils'
import Request from '../../request'
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";

// import DealerDashboard from './dealerDashboard'

let intVar = null

class Notification extends Component {
    constructor(props) {
        super(props)
        this.table = React.createRef();
        this.state = {
            count:0
        }
    }

    apiRequest = (params, columns) => {
        return new Promise(async resolve => {

            params.sortField = 'lastMessageTime'
            params.sortOrder = 'descend'
            let data = await Request.fetchAllNotifications({
                ...params
            })

            this.setState({count: data.total})
            resolve(data)
        })
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        clearInterval(intVar);
    }

    markNotificationAsRead = async(_id) => {
        let _ids = [_id];
        await Request.markAsReadNotify({ _ids });
        this.table.current.reload()
    }

    render() {
        
        const columns = [
            {
                title: "From",
                key: "from",
                dataIndex: "createdByUser.name",
                sorter: false,
            },
            {
                title: "Description",
                key: "description",
                dataIndex: "description",
                sorter: false,
            },
            {
                title: "Status",
                key: "viewed",
                dataIndex: "viewed",
                render: (text, record) => (
                    <div>
                        <React.Fragment>
                            {text === true?<FaRegEye/>:<button onClick={() => {this.markNotificationAsRead(record._id)}}><FaRegEyeSlash/></button>}
                        </React.Fragment>
                    </div>
                )
            }
        ]
        return (
            <PageHeaderWrapper
                title={'All Notifications:- '+ this.state.count}
            >
                <Card>
                    <TableComp 
                        columns={columns} 
                        ref={this.table}
                        id={'notification-table'}
                        showSelector={true}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 100,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global}) => ({
    categories: global.categories,
    loading: global.buttonLoading,
    currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Notification)
